<app-sub-navbar></app-sub-navbar>

<!-- Banner Background -->
<section
  [style.background-image]="'url(' + collectionData?.bannerUrl + ')'"
  class="header-filter-collection py-5 view-collection-banner text-center"
>
  <div class="container header">
    <div class="row py-lg-5">
      <div class="col-lg-6 col-md-8 mx-auto">
        <h1 class="fw-semi">{{ collectionData?.collectionName }}</h1>
      </div>
    </div>
  </div>
</section>

<!-- content -->

<section class="py-5 container">
  <div class="masonry">
    <div class="masonry-item" *ngFor="let data of collectionsFiles">
      <figure class="showcase" [class.loading]="!data.imageLoad">
        <div class="badge-wrap" *ngIf="data.isPremium && data.imageLoad">
          <span class="badge rounded cursor text-bg-dark">Pro</span>
        </div>

        <!-- Skeleton (auto visible before image load) -->
        <div class="skeleton" *ngIf="!data.imageLoad"></div>

        <a
          *ngIf="data.jpeg || data.png"
          [routerLink]="'/ai-image/' + data.slug"
        >
          <img
            [src]="data?.previewUrl || data.jpeg || data.png"
            [alt]="data.title"
            class="radius-md img-fluid"
            (load)="data.imageLoad = true"
          />

          <figcaption class="hide-caption figure-caption">
            <p>{{ data.title }}</p>
          </figcaption>
        </a>
      </figure>
    </div>

    <div
      class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center"
      *ngIf="collectionsFiles.length === 0 && !loader"
    >
      <div class="container">
        <img
          style="height: 200px"
          class="img-fluid mb-3"
          src="assets/img/no-data-found.svg"
          alt="No Data Found"
        />
        <h1 class="fw-bold fs-4 text-dark mb-2">Illustration not available</h1>
        <p class="mb-4 text-dark">
          We couldn't load the illustration at the moment.
        </p>
        <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
      </div>
    </div>
  </div>
  <!-- 
  <div class="py-3 pad-top px-4 text-center">
    <a routerLink="/" class="btn btn-ib-red">
      Next Page &nbsp;<i class="fas fa-arrow-right"></i
    ></a>
  </div> -->
</section>
